import Layout from '../views/layout/Layout'

export default {
  path: '/software',
  component: Layout,
  redirect: '/software/softwareList',
  name: 'software',
  meta: {title: '软件管理', icon: 'software'},
  children: [
    {
      path: 'softwareList',
      name: 'softwareList',
      component: () => import('@/views/software/softwareList/index'),
      meta: {title: '软件列表', icon: 'software-list'}
    },
    {
      path: 'softwareModuleList',
      name: 'softwareModuleList',
      component: () => import('@/views/software/softwareModuleList/index'),
      meta: {title: '软件模块', icon: 'module'}
    },
    {
      path: 'infoList',
      name: 'infoList',
      component: () => import('@/views/software/infoList/index'),
      meta: {title: '异常列表', icon: 'info'}
    },
    {
      path: 'logList',
      name: 'logList',
      component: () => import('@/views/software/logList/index.vue'),
      meta: {title: '接口日志', icon: 'new-log'}
    },
    {
      path: 'softwareList/edit',
      name: 'softwareList',
      component: () => import('@/views/software/softwareList/edit'),
      meta: {title: '软件信息', icon: 'software-list'},
      hidden: true
    },
    {
      path: 'softwareModuleList/edit',
      name: 'softwareModuleList',
      component: () => import('@/views/software/softwareModuleList/edit'),
      meta: {title: '软件模块信息', icon: 'software-list'},
      hidden: true
    },
    {
      path: 'softwareList/more',
      name: 'softwareMore',
      component: () => import('@/views/software/softwareList/more'),
      meta: {title: '软件更多信息', icon: 'software-list'},
      hidden: true
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/software.js